var _defs, _g, _rect, _circle, _rect2, _path, _circle2, _polygon, _polygon2, _polygon3, _rect3, _rect4, _rect5, _path2, _rect6, _rect7, _circle3, _path3, _circle4, _g2, _circle5, _path4, _path5, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStateMyListings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 248 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{clip-path:url(#clip-path-3);}.cls-6{clip-path:url(#clip-path-4);}.cls-7{fill:#77c5f2;opacity:0.11;}.cls-8{fill:#26415e;}.cls-9{fill:#182a3a;}.cls-10{fill:#4cabe1;}.cls-11{fill:#d9f0f9;}.cls-12{fill:#fff;}.cls-13{fill:#cee5ef;}.cls-14{opacity:0.15;}.cls-15{clip-path:url(#clip-path-5);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.68-50.6C109.3-27.47,64.07-19,38.53-27.48.79-50.6.79-86.37.79-114.75c4.4-45.12,29.91-48.29,105-28.61,70.58,15,67.8-77.7,124.85-16.51,12.24,17.41,30.68,58.18-3.29,89.83C194.39-39.31,163.65-92.7,128.68-50.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.9,130.4c19.38,23.13,64.61,31.56,90.15,23.12,37.74-23.12,37.74-58.89,37.74-87.27-4.39-45.12-29.9-48.29-105-28.61-70.59,15-67.81-77.7-124.86-16.51-12.24,17.41-30.68,58.18,3.3,89.83C322.2,141.69,352.93,88.3,387.9,130.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.9,130.4c19.38,23.13,64.61,31.56,90.15,23.12,37.74-23.12,37.74-58.89,37.74-87.27-4.39-45.12-29.9-48.29-105-28.61C71.18,52.63,74-40.06,16.91,21.13,4.67,38.54-13.77,79.31,20.21,111,53.2,141.69,83.93,88.3,118.9,130.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -61.7,
    y: -265.67,
    width: 371.98,
    height: 661.62
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.55,
    y: 46.97,
    width: 22.28,
    height: 10.31
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ilustrac\u0327a\u0303o empty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: -4.17,
    y: -4.96,
    width: 255.92,
    height: 166.65
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 22.24,
    y: 142.4,
    width: 203.53,
    height: 10.63,
    rx: 0.55,
    ry: 0.55
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 170.17,
    cy: 136.56,
    r: 6.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 53.45,
    y: 127.8,
    width: 137.79,
    height: 10.89
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M196.5,105.55H180.42l-1.11-2.09a4.5,4.5,0,0,0-3-7.86,4.42,4.42,0,0,0-1.1.15L155.3,58.23a1.85,1.85,0,0,0-1.63-1H72.85a1.85,1.85,0,0,0-1.78,1.37L58.53,105.55h-8a1.84,1.84,0,0,0-1.84,1.84V135a1.85,1.85,0,0,0,1.84,1.84H62.92a1.92,1.92,0,0,1,0-.24c0-4.05,3.76-7.34,7.81-7.34s7.8,3.29,7.8,7.34v.24h30.8c.13-4.21,4-7.58,8.28-7.58s8.14,3.37,8.27,7.58H196.5a1.85,1.85,0,0,0,1.84-1.84V107.39A1.84,1.84,0,0,0,196.5,105.55Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 70.73,
    cy: 138.46,
    r: 6.39
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "174.19 105.55 128.73 105.55 117.84 62.93 152.88 62.93 174.19 105.55"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "120.21 105.55 90.38 105.55 90.38 62.93 110.27 62.93 120.21 105.55"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "83.75 105.55 63.39 105.55 74.75 62.93 83.75 62.93 83.75 105.55"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 133,
    y: 125.43,
    width: 69.13,
    height: 8.08,
    rx: 4.01,
    ry: 4.01
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 45.53,
    y: 125.96,
    width: 10.31,
    height: 7.55,
    rx: 3.75,
    ry: 3.75
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 139.15,
    y: 116.44,
    width: 12.31,
    height: 5.68,
    rx: 2.82,
    ry: 2.82
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M48.66,118.46h2a2.82,2.82,0,0,1,2.82,2.82v0a2.82,2.82,0,0,1-2.82,2.82h-2a0,0,0,0,1,0,0v-5.68a0,0,0,0,1,0,0Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 181.77,
    y: 116.44,
    width: 12.31,
    height: 5.68,
    rx: 2.82,
    ry: 2.82
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 157.14,
    y: 126.86,
    width: 22.73,
    height: 5.68
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 117.61,
    cy: 138.46,
    r: 6.39
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M115.48,109.9l-3.91-6.78a4.69,4.69,0,1,0-1.24,1.18l3.71,6.43Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 117.61,
    cy: 138.46,
    r: 1.81
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M126.06,58.37A2.13,2.13,0,0,0,123.72,56l-18.15.82-27,26.93,19.64,19.68,27-26.93Zm-6.24,3.89a2.12,2.12,0,1,1,3,0A2.13,2.13,0,0,1,119.82,62.26Z"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 70.73,
    cy: 138.46,
    r: 1.81
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M126.06,54.51a2.13,2.13,0,0,0-2.34-2.35L105.57,53l-27,26.93L98.24,99.58l27-26.93Zm-6.24,3.88a2.12,2.12,0,1,1,3,0A2.12,2.12,0,0,1,119.82,58.39Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M98.48,81.79l-1.66,1.65L95,81.65l1.59-1.59A11.34,11.34,0,0,1,94,75.16L97.14,74a9.27,9.27,0,0,0,2.41,4.47c1.22,1.23,2,1.36,2.55.86,1.65-1.66-5.48-6.38-1.6-10.25,1.64-1.64,4.2-1.85,6.91.27l1.64-1.64,1.79,1.79-1.61,1.61a10.26,10.26,0,0,1,2.14,3.9l-3.1,1.28a8.8,8.8,0,0,0-2.08-3.69c-1.24-1.24-2.1-1.27-2.62-.75-1.6,1.59,5.5,6.32,1.66,10.16C103.65,83.54,101.14,83.77,98.48,81.79Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M130.6,68.7A10.68,10.68,0,1,1,141.28,58,10.69,10.69,0,0,1,130.6,68.7Zm0-20.63a9.95,9.95,0,1,0,9.94,10A10,10,0,0,0,130.6,48.07Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateMyListings);
export default __webpack_public_path__ + "static/media/empty-state-my-listings.150b7595.svg";
export { ForwardRef as ReactComponent };